export default __webpack_public_path__ + "static/media/topbannerboarder.b33b4044.svg";